export default [
  {
    path: '/ums-demo',
    name: 'UMSDemo',
    component: './Demo',
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: './Privacy',
  },
  {
    path: '/user',
    component: '../layouts/BlankLayout',
    routes: [
      {
        path: '/user',
        redirect: '/user/login',
      },
      {
        name: '登录',
        icon: 'smile',
        path: '/user/login',
        component: './user/login',
      },
      {
        component: './exception/404',
      },
    ],
  },

  {
    path: '/',
    component: '../layouts/BasicLayout',
    routes: [
      {
        path: '/',
        redirect: '/workbench/index',
      },
      {
        path: '/workbench/index',
        name: '首页',
        icon: 'icon-shouye1',
        component: './FirstPage',
        hideHeader: true,
      },
      {
        name: '数据大屏',
        icon: 'iconbar-chart-box-line',
        path: '/screen',
        routes: [
          {
            path: '/screen',
            redirect: '/screen/quality',
          },
          {
            name: '集团质量监控',
            path: '/screen/quality',
            component: './screen/quality',
            hideHeader: true,
          },
          {
            name: '预警处理监控',
            path: '/screen/alert',
            component: './screen/alert',
            hideHeader: true,
          },
        ],
      },
      {
        name: '数据监控',
        icon: 'iconbar-chart-box-line',
        path: '/data',
        routes: [
          {
            name: '质检总览',
            path: '/data/stats',
            component: './data/stats',
            hideHeader: true,
          },
          {
            name: '质培任务分析',
            path: '/data/analyse',
            component: './data/analyse',
            hideHeader: true,
          },
          {
            name: '实时会话监控',
            path: '/data/dialog',
            // 原属于组长监控的子页面，【https://project.feishu.cn/dev_demands/story/detail/5311398696】需求迁移到数据监控下面
            component: './monitor/customerMonitor',
            hideHeader: true,
          },
          {
            component: './render',
          },
        ],
      },

      {
        name: '套购推荐分析',
        icon: 'icon-shangpu',
        path: '/meidi',
        routes: [
          {
            component: './render',
          },
        ],
      },

      {
        name: '套购推荐分析',
        icon: 'icon-shangpu',
        path: '/meidi2',
        routes: [
          {
            component: './render',
          },
        ],
      },

      {
        name: '拼多多报表数据',
        icon: 'icon-shangpu',
        path: '/pddReports',
        routes: [
          {
            component: './render',
          },
        ],
      },

      {
        name: 'VOC',
        icon: 'icon-zhuanshi',
        path: '/voc',
        routes: [
          {
            name: '商品咨询热点',
            path: '/voc/hot',
            hideHeader: true,
            routes: [
              {
                name: '咨询原声详情',
                path: '/voc/hot/trt',
                component: './voc/trt',
              },
              {
                name: '自助洞察分析',
                path: '/voc/hot/insight',
                component: './voc/insight',
                hideHeader: true,
              },
              {
                name: '咨询场景管理',
                path: '/voc/hot/scene',
                component: './voc/scene',
                hideHeader: true,
              },
              {
                component: './render',
              },
            ],
          },
          {
            name: '商品流失分析',
            path: '/voc/analysis',
            hideHeader: true,
            routes: [
              {
                name: '流失原因分析',
                path: '/voc/analysis/result',
                component: './voc/result',
                hideHeader: true,
                hideInMenu: true,
              },
              {
                name: '流失原因分析-doris',
                path: '/voc/analysis/dorisresult',
                component: './voc/doris_result',
                hideHeader: true,
                hideInMenu: true,
              },
              {
                name: '流失配置管理',
                path: '/voc/analysis/configure',
                component: './voc/configure',
                hideHeader: true,
              },
              {
                name: '商品流失详情',
                path: '/voc/analysis/detail',
                component: './voc/detail',
              },
              {
                name: '商品流失详情-doris',
                path: '/voc/analysis/dorisdetail',
                component: './voc/doris_detail',
              },
              {
                name: '商品管理',
                path: '/voc/analysis/goods',
                component: './voc/goods',
                hideHeader: true,
              },
              {
                component: './render',
              },
            ],
          },
          {
            component: './render',
          },
        ],
      },
      {
        name: '质检方案',
        icon: 'iconfile-shield-2-line',
        path: '/standard',
        routes: [
          {
            path: '/standard',
            redirect: '/standard/list',
          },
          {
            name: '质检标准',
            path: '/standard/list',
            component: './standard/list',
            hideHeader: true,
          },
          {
            name: '质检项管理',
            path: '/standard/management',
            component: './standard/management/_layout',
            hideHeader: true,
          },
          {
            name: '标准修订记录',
            path: '/standard/list/log',
            component: './standard/log',
            hideHeader: true,
            hideInMenu: true,
          },
          {
            name: '编辑规则',
            path: '/standard/list/edit/:id',
            component: './standard/edit',
            hideInMenu: true,
            hideHeader: true,
          },
        ],
      },

      {
        name: '质检会话',
        icon: 'iconchat-4-line',
        path: '/dialog',
        routes: [
          {
            path: '/dialog',
            redirect: '/dialog/list',
          },
          {
            name: '质检会话列表',
            path: '/dialog/list',
            component: './dialog/list',
            hideHeader: true,
          },
          {
            name: '历史会话查询',
            path: '/dialog/history',
            component: './dialog/history',
            hideHeader: true,
          },
          // 新建高级搜索
          {
            name: '高级搜索设置',
            path: '/dialog/radar',
            component: './dialog/radar',
            hideInMenu: true,
            hideHeader: true,
          },
          // 编辑高级搜索
          {
            name: '高级搜索设置',
            path: '/dialog/radar/:id',
            component: './dialog/radar',
            hideInMenu: true,
            hideHeader: true,
          },
        ],
      },
      {
        name: '人工质检',
        icon: 'iconuser-follow-line',
        path: '/check',
        routes: [
          {
            path: '/check',
            redirect: '/check/task',
          },
          {
            name: '质检任务列表',
            path: '/check/task',
            routes: [
              {
                path: '/check/task',
                redirect: '/check/task/list',
              },
              {
                name: '质检任务',
                path: '/check/task/list',
                component: './check/task',
                hideInMenu: true,
                hideHeader: true,
              },
              {
                name: '质检任务详情',
                path: '/check/task/detail/:id',
                component: './check/detail',
                hideInMenu: true,
                hideHeader: true,
              },
            ],
          },

          {
            name: '质检任务记录',
            path: '/check/record',
            routes: [
              {
                path: '/check/record',
                redirect: '/check/record/list',
              },
              {
                name: '质检任务记录',
                path: '/check/record/list',
                component: './check/record',
                hideInMenu: true,
                hideHeader: true,
              },
              {
                name: '质检任务详情',
                path: '/check/record/detail/:id',
                component: './check/detail',
                hideInMenu: true,
                hideHeader: true,
              },
            ],
          },
        ],
      },

      {
        name: '质检报表',
        icon: 'iconfile-list-2-line',
        path: '/report',
        hideHeader: true,
        routes: [
          {
            path: '/report',
            redirect: '/report/stat/platform',
          },
          {
            path: '/report/stat',
            component: './report/_layout',
            hideInMenu: true,
            routes: [
              {
                path: '/report/stat/platform',
                component: './report/platform/list',
              },
              {
                path: '/report/stat/shop',
                component: './report/shop/list',
              },
              {
                path: '/report/stat/customer',
                component: './report/customer/list',
              },
            ],
          },
          {
            name: '店铺详情',
            path: '/report/shop/detail',
            component: './report/shop/detail',
            hideInMenu: true,
          },
          {
            name: '客服详情',
            path: '/report/customer/detail',
            component: './report/customer/detail/layout',
            hideInMenu: true,
            routes: [
              {
                path: '/report/customer/detail/result',
                component: './report/customer/detail/result',
              },
              {
                path: '/report/customer/detail/ai',
                component: './report/customer/detail/ai',
              },
              {
                path: '/report/customer/detail/man',
                component: './report/customer/detail/man',
              },
            ],
          },
        ],
      },

      {
        name: '案例管理',
        icon: 'iconstack-line',
        path: '/case',
        routes: [
          {
            path: '/case',
            redirect: '/case/dialog',
          },
          {
            name: '会话案例',
            path: '/case/dialog',
            component: './case/dialog',
            hideHeader: true,
          },
          {
            name: '审批详情',
            path: '/case/approve/detail/:id',
            component: './case/approve/detail',
            hideHeader: true,
            hideInMenu: true,
          },
          {
            name: '审批中心',
            path: '/case/approve',
            component: './case/approve',
            hideHeader: true,
          },
        ],
      },

      {
        name: '质检报表',
        icon: 'iconfile-list-2-line',
        path: '/qcTable',
        routes: [
          {
            path: '/qcTable/statistics',
            name: '自助报表',
            component: './report/statistics',
            hideHeader: true,
          },
          {
            component: './render',
          },
        ],
      },

      {
        name: '质检申诉',
        icon: 'iconshape-2-line',
        path: '/appeal',
        routes: [
          {
            path: '/appeal',
            redirect: '/appeal/myself',
          },
          {
            name: '我的申诉',
            path: '/appeal/myself',
            component: './appeal/myself',
            hideHeader: true,
          },
          {
            name: '主管申诉处理',
            path: '/appeal/charge',
            component: './appeal/charge',
            hideHeader: true,
          },
          {
            name: '质检员申诉处理',
            path: '/appeal/quality',
            component: './appeal/quality',
            hideHeader: true,
          },
          {
            name: '任务详情',
            path: '/appeal/detail/:id',
            component: './appeal/detail',
            hideHeader: true,
            hideInMenu: true,
          },
        ],
      },
      {
        name: '质培任务',
        icon: 'iconshape-2-line',
        path: '/train',
        routes: [
          {
            path: '/train',
            redirect: '/train/tasks',
          },
          {
            name: '任务列表',
            path: '/train/tasks',
            component: './train/tasks',
            hideHeader: true,
            hideInMenu: true,
          },
          {
            name: '任务详情',
            path: '/train/detail/:id',
            component: './train/detail',
            hideHeader: true,
            hideInMenu: true,
          },
        ],
      },
      {
        name: '组长监控',
        icon: 'icontime',
        path: '/monitor',
        tip: '仅有下级的账号可使用',
        routes: [
          {
            path: '/monitor',
            redirect: '/monitor/abnormals',
          },
          {
            name: '实时质检监控',
            path: '/monitor/abnormals',
            component: './monitor/abnormals',
            hideHeader: true,
          },
        ],
      },
      {
        name: '基础管理',
        icon: 'iconuser-settings-line',
        path: '/system',
        tip: '基础管理不区分平台',
        hidePlatform: true,
        routes: [
          {
            path: '/system',
            redirect: '/system/shop',
          },
          {
            name: '店铺管理',
            path: '/system/shop',
            component: './system/shop',
            hideHeader: true,
          },
          {
            name: '子账号管理',
            path: '/system/department',
            component: './system/department',
            hideHeader: true,
          },
          {
            name: '人员管理',
            path: '/system/snick',
            component: './system/snick',
            hideHeader: true,
          },
          {
            name: '角色权限管理',
            path: '/system/role',
            component: './system/role',
            hideHeader: true,
          },
          {
            name: '组织架构设置',
            path: '/system/org',
            component: './system/org',
            hideHeader: true,
          },
          {
            name: '案例标签管理',
            path: '/system/caseLabel',
            component: './system/caseLabel',
            hideHeader: true,
          },
          {
            name: '场景标签管理',
            path: '/system/sceneLabel',
            component: './system/sceneLabel',
            hideHeader: true,
          },
          {
            name: '消除识别记录',
            path: '/system/eliminateLabels',
            component: './system/eliminateLabels',
            hideHeader: true,
          },
        ],
      },
      {
        name: '企业管理',
        icon: 'iconuser-settings-line',
        path: '/company',
        routes: [
          {
            path: '/company',
            redirect: '/company/manage',
          },
          {
            name: '企业管理',
            icon: 'icontime',
            path: '/company/manage',
            component: './company/manage',
            hideHeader: true,
          },
          {
            name: '店铺管理',
            path: '/company/shop/:id',
            component: './company/shop',
            hideInMenu: true,
            hideHeader: true,
          },
        ],
      },
      {
        name: '质检报表',
        icon: 'icon-wenzhang',
        path: '/reportConfig',
        routes: [
          {
            path: '/reportConfig',
            redirect: '/reportConfig/configuration',
          },
          {
            name: '报表配置',
            path: '/reportConfig/configuration',
            component: './report/statistics/configPage',
            hideHeader: true,
          },
          {
            path: '/reportConfig/statistics',
            name: '自助报表',
            component: './report/statistics',
            hideHeader: true,
          },
          {
            path: '/reportConfig/voc',
            name: 'VOC洞察报表',
            component: './voc/insight',
            hideHeader: true,
          },
                 {
            path: '/reportConfig/new_bi',
            name: 'new_bi_报表',
            component: './report/newBi/insight',
            hideHeader: true,
          },
        ],
      },
      {
        name: 'VOC.AI 报表',
        icon: 'icon-wenzhang',
        path: '/voc_ai_reportConfig',
        routes: [
          {
            path: '/voc_ai_reportConfig',
            redirect: '/voc_ai_reportConfig/configuration',
          },
          {
            name: '报表配置',
            path: '/voc_ai_reportConfig/configuration',
            component: './report/statisticsVocAi/vocAIConfigPage',
            hideHeader: true,
          },
          {
            path: '/voc_ai_reportConfig/statistics',
            name: 'VOC AI数据洞察',
            component: './report/statisticsVocAi/insight',
            hideHeader: true,
          },
          {
            path: '/voc_ai_reportConfig/new_statistics',
            name: 'new_bi_报表',
            component: './report/newBi/insight',
            hideHeader: true,
          },
        ],
      },
      {
        name: '告警推送',
        path: '/alarm',
        hideInMenu: true,
        hideHeader: true,
        component: './alarm',
      },

      {
        path: '/404',
        component: './exception/404',
      },
      {
        path: '/403',
        component: './exception/403',
      },
      {
        component: './render',
      },
    ],
  },
]
